import { SvgIcon, SvgIconProps } from '@mui/material'

export const IconEyeOpen = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 10.9375C3 10.9375 6.5625 5 12.5 5C18.4375 5 22 10.9375 22 10.9375V13.3125C22 13.3125 18.4375 19.25 12.5 19.25C6.5625 19.25 3 13.3125 3 13.3125V10.9375ZM12.5 15.6875C14.4675 15.6875 16.0625 14.0925 16.0625 12.125C16.0625 10.1575 14.4675 8.5625 12.5 8.5625C10.5325 8.5625 8.9375 10.1575 8.9375 12.125C8.9375 14.0925 10.5325 15.6875 12.5 15.6875Z"
        fill="#E5E5E5"
      />
    </SvgIcon>
  )
}
